import React from 'react';
import facebookThumb from "images/social-media/facebook-thumb.png"
import youtubeThumb from "images/social-media/youtube-thumb.png"
import instagramThumb from "images/social-media/instagram-thumb.png"
import netappNIcon from "ui-components/src/images/monochrome-icons/netapp-n-icon.png"
import calendarIcon from "ui-components/src/images/monochrome-icons/calendar-icon.png"
import commentIcon from "ui-components/src/images/monochrome-icons/comment-icon.png"
import ExternalLink from './../../../../components/widgets/ExternalLink'
import SlidingHeaderMenu from "../SlidingHeaderMenu";

export default ({isActive, triggerClass, closeTrigger}) => (
    <SlidingHeaderMenu className="right-side-menu" title="Community" isActive={isActive} triggerClass={triggerClass} closeTrigger={closeTrigger}>
        <div className="community-menu-content">
            <div className="social-media-selector">
                <ExternalLink linkKey="community.facebook" newTab><img src={facebookThumb} alt="Facebook" /></ExternalLink>
                <ExternalLink linkKey="community.youtube" newTab><img src={youtubeThumb} alt="YouTube" /></ExternalLink>
                <ExternalLink linkKey="community.instagram" newTab><img src={instagramThumb} alt="Instagram" /></ExternalLink>
            </div>
            <div className="community-selector">
                <img src={netappNIcon} alt="NetApp Community icon"/>
                <h4>NetApp Community</h4>
                <p>Talk with other members about NetApp public and hybrid cloud solutions</p>
                <ExternalLink className="button-like" linkKey="community.community" newTab>NetApp Community</ExternalLink>
            </div>
            <div className="community-selector">
                <img src={calendarIcon} alt="Calendar icon"/>
                <h4>NetApp Events</h4>
                <p>Live Events and Webinar On Demand</p>
                <ExternalLink className="button-like" linkKey="community.events" newTab>NetApp Events</ExternalLink>
            </div>
            <div className="community-selector">
                <img src={commentIcon} alt="Blog icon"/>
                <h4>NetApp Blog</h4>
                <p>Cloud News and Articles</p>
                <ExternalLink className="button-like" linkKey="community.blog" newTab>NetApp Blog</ExternalLink>
            </div>
        </div>
    </SlidingHeaderMenu>
)
